<template>
  <div>
    <div class="charts-container">
      <el-row>
        <el-col>
          <ContentBox title="地域分布图">
            <div v-if="regionOption.series[0].data.length" class="chart-area">
              <el-row>
                <el-col :span="12">
                  <div>
                    <Echarts elId="ChinaMap" :option="regionOption" height="400px" width="50%"></Echarts>
                  </div>
                </el-col>
                <el-col :span="12">
                  <VeBar ref="bar" :data="barData" :loading="loading" :extend="barExtend"></VeBar>
                </el-col>
              </el-row>
            </div>
            <div v-else class="no-message">
              <ChartDataEmpty />
            </div>
          </ContentBox>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <ContentBox>
            <div class="download" slot="title">
              <p class="title">详细数据</p>
              <p class="title-right">
                <el-button size="mini">
                  <i class="el-icon-cc-unorderedlist" style="font-size: 12px;padding-right:4px"></i>导出
                </el-button>
              </p>
            </div>
            <Table :props="table.props" :header="table.header" :data="table.data" />
            <pagination
              v-bind:currentpage="currentPage"
              v-bind:pagesize="pageSize"
              v-bind:totalcount="totalCount"
              @handle-size-change="handleSizeChange"
              @handle-current-change="handleCurrentChange"
            ></pagination>
          </ContentBox>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import ChartDataEmpty from '@/components/ChartDataEmpty'
// import VeMap from 'v-charts/lib/map.common'
import VeBar from 'v-charts/lib/bar.common'
import 'echarts/lib/component/legendScroll'
import 'echarts/lib/component/visualMap'
import 'v-charts/lib/style.css'
import Echarts from '@/components/charts/Echarts.vue'
export default {
  components: {
    // VeMap,
    Echarts,
    VeBar,
    ChartDataEmpty
  },
  data() {
    this.barExtend = {
      legend: {
        show: false
      },
      tooltip: {
        confine: true
      },
      grid: {
        top: '2%',
        bottom: -10,
        right: 30,
        left: -30,
        containLabel: true
      },
      series: {
        roam: false,
        visualMap: false,
        zlevel: 2,
        barMaxWidth: 8,
        barGap: 0
      },
      yAxis: {
        type: 'category',
        inverse: true,
        nameGap: 16,
        axisLine: {
          show: false,
          lineStyle: {
            color: '#333'
          }
        },
        axisTick: {
          show: false,
          lineStyle: {
            color: '#ddd'
          }
        },
        axisLabel: {
          interval: 0,
          color: '#666',
          align: 'left',
          margin: 90,
          fontSize: 13,
          rich: {
            idx0: {
              color: '#ffffff',
              backgroundColor: '#FF8B00',
              borderRadius: 20,
              // padding: [10, 18]
              width: 20,
              height: 20,
              align: 'center'
            },
            idx1: {
              color: '#ffffff',
              backgroundColor: '#FF8B00',
              borderRadius: 20,
              width: 20,
              height: 20,
              align: 'center'
            },
            idx2: {
              color: '#ffffff',
              backgroundColor: '#FF8B00',
              borderRadius: 20,
              width: 20,
              height: 20,
              align: 'center'
            },
            idx: {
              color: 'rgba(0,0,0,0.65)',
              backgroundColor: '#F0F2F5',
              borderRadius: 20,
              width: 20,
              height: 20,
              align: 'center'
            },
            title: {
              width: 80
            }
          },
          formatter: function (value, index) {
            if (index < 3) {
              return '{idx' + index + '|' + (1 + index) + '} {title|' + value + '}'
            } else {
              return '{idx|' + (1 + index) + '} {title|' + value + '}'
            }
          }
        }
      },
      xAxis: {
        show: false,
        splitLine: {
          // 坐标轴在 grid 区域中的分隔线。
          show: false
        }
      }
    }
    return {
      isShowSelect: false,
      isShowTimePicker: true,
      activeName: 'audienceCharts',
      // 分页
      pageSize: 10,
      currentPage: 1,
      totalCount: 1,
      table: {
        props: {
          border: true,
          'tooltip-effect': 'dark'
        },
        header: [
          {
            label: '日期',
            align: 'left',
            prop: 'statData',
            'show-overflow-tooltip': true
          },
          {
            label: '省份',
            align: 'left',
            prop: 'provinceName',
            'show-overflow-tooltip': true
          },
          {
            label: '城市',
            align: 'left',
            prop: 'cityName',
            'show-overflow-tooltip': true
          },
          {
            label: '计划名称',
            align: 'left',
            prop: 'scheduleName',
            isShow: true,
            width: 200,
            'show-overflow-tooltip': true
          },
          {
            label: '广告位',
            align: 'left',
            prop: 'spaceName',
            'show-overflow-tooltip': true
          },
          // {
          //   label: '素材名称',
          //   align: 'left',
          //   prop: 'mediaName',
          //   'show-overflow-tooltip': true
          // },
          {
            label: '曝光量(PV)',
            align: 'right',
            prop: 'pv',
            'show-overflow-tooltip': true,
            formatter: (params) => {
              return (params.pv || 0).toLocaleString()
            }
          }
        ],
        data: []
      },
      barData: {
        columns: ['位置', 'pv'],
        rows: []
      },
      regionOption: {
        tooltip: {
          triggerOn: 'mousemove',
          formatter: function (e, t, n) {
            return e.seriesName + '<br />' + e.name + ':' + e.value
          }
        },
        visualMap: {
          min: 0,
          max: 100,
          show: false
        },
        geo: {
          map: 'china',
          center: [108, 35],
          roam: !1,
          scaleLimit: {
            min: 1,
            max: 2
          },
          zoom: 1.1,
          label: {
            normal: {
              show: !0,
              fontSize: '12',
              color: 'rgba(0,0,0,0.7)'
            }
          },
          itemStyle: {
            normal: {
              borderColor: 'rgba(0, 0, 0, 0.5)'
            },
            emphasis: {
              areaColor: '#f2d5ad',
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              borderWidth: 0
            }
          }
        },
        series: [{
          name: '曝光量',
          type: 'map',
          geoIndex: 0,
          data: []
        }]
      },
      loading: false
      // screenWidth: document.documentElement.clientWidth,
      // sortHeight: 76
    }
  },
  props: {
    scheduleChartData: {
      type: Object
    }
  },
  watch: {
    scheduleChartData: {
      handler(newValue, oldValue) {
        this.fetchData()
      },
      deep: true
    }
  },
  computed: {},
  methods: {
    // 每页显示数据量变更, 如每页显示10条变成每页显示20时,val=20
    handleSizeChange: function (val) {
      this.pageSize = val
      this.currentPage = 1
      this.getTableData()
    },
    // 页码变更, 如第1页变成第2页时,val=2
    handleCurrentChange: function (val) {
      this.currentPage = val
      this.getTableData()
    },
    fetchData() {
      if (this.scheduleChartData.orderId) {
        this.loading = true
        const form = {
          orderId: this.scheduleChartData.orderId,
          scheduleId: this.scheduleChartData.scheduleId,
          showType: this.scheduleChartData.showType,
          beginDate: this.$moment(this.scheduleChartData.time[0]).format('YYYY-MM-DD'),
          endDate: this.$moment(this.scheduleChartData.time[1]).format('YYYY-MM-DD')
        }
        this.$service.getAreaReport(form).then((data) => {
          this.loading = false
          let rows = []
          // let columns = ['位置', 'pv']
          let barRows = []
          data.regionList.forEach((item) => {
            let provinceName = item.provinceName.replace('省', '').replace('市', '')
            provinceName =
              provinceName.length > 3 ? provinceName.slice(0, 2) : provinceName
            if (provinceName === '内蒙') {
              provinceName = '内蒙古'
            }
            rows.push({
              位置: provinceName,
              pv: item.pv
            })
            barRows.push({
              位置: provinceName,
              pv: parseInt(item.pv)
            })
          })
          this.regionOption.series[0].data = rows
          this.barData.rows =
            barRows.length > 20
              ? barRows.splice(0, 20).sort((a, b) => b.pv - a.pv)
              : barRows.sort((a, b) => b.pv - a.pv)
        })
        this.pageSize = 10
        this.currentPage = 1
        this.getTableData()
      }
    },
    getTableData() {
      const form = {
        orderId: this.scheduleChartData.orderId,
        scheduleId: this.scheduleChartData.scheduleId,
        showType: this.scheduleChartData.showType,
        beginDate: this.$moment(this.scheduleChartData.time[0]).format('YYYY-MM-DD'),
        endDate: this.$moment(this.scheduleChartData.time[1]).format('YYYY-MM-DD'),
        pageSize: this.pageSize,
        pageNo: this.currentPage
      }
      this.$service.getRegionPageList(form).then((data) => {
        this.table.data = data.rows || []
        const totalCount = Number(data.total)
        this.totalCount = isNaN(totalCount) ? 0 : totalCount
      })
    }
  },
  created() {
    this.fetchData()
  }
}
</script>
<style lang="stylus" scoped>
.charts-container
  background #f2f2f2
  padding 16px 16px 0px
  overflow auto
  height calc(100vh - 176px)
.chart-title, .download
  width 100%
  display flex
  justify-content space-between
  padding-right 20px
  align-items center
.no-message
  text-align center
  height 300px
</style>
